import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_53: DocMigration = {
  maxSchemaVersion: "0.0.53",
  description: "Flatten blocks",
  apply(json: any) {
    if (json.rooms) {
      return json;
    }

    json.rooms = {};
    json.roomLayouts = {};

    const handleHashToRoomId = {};
    const dashIdToNewRoomId = {};

    for (const blockId in json.blocks) {
      const block = json.blocks[blockId];

      let sortIndex: number = 0;
      for (const locationId in block.rooms) {
        const room = block.rooms[locationId];

        const id = uid();
        room.sortIndex = sortIndex++;
        room.id = id;
        room.blockId = blockId;

        dashIdToNewRoomId[blockId + "-" + locationId] = room.id;
        handleHashToRoomId[`room.${blockId}.${locationId}`] = room.id;

        json.rooms[room.id] = room;

        if (room.layout) {
          json.roomLayouts[room.id] = room.layout;
        }
      }

      delete block.rooms;
    }

    // remap design param values
    if (json.design?.roomParamValues) {
      for (const oldRoomId in json.design.roomParamValues) {
        json.design.roomParamValues[dashIdToNewRoomId[oldRoomId]] = json.design.roomParamValues[oldRoomId];
        delete json.design.roomParamValues[oldRoomId];
      }
    }

    // fix electrical system roomId references
    function convertRoomHandleHash(roomId: string) {
      if (!(roomId.startsWith("room."))) {
        console.assert(false, roomId);
      }

      // room.blockId.locationId
      const idSplit = roomId.split(".");

      if (!(idSplit.length === 3)) {
        console.assert(false);
      }
      const blockId = idSplit[1];
      const locationId = idSplit[2];
      const hash = `room.${blockId}.${locationId}`;

      if (!handleHashToRoomId[hash]) {
        return null;
      }

      return handleHashToRoomId[hash];
    }

    function convertRoomHandleHashTable(elems: { [key: string]: any }) {
      if (!elems) {
        return;
      }

      for (const roomHash of Object.keys(elems)) {
        const val = elems[roomHash];
        delete elems[roomHash];
        const hash = convertRoomHandleHash(roomHash);
        if (!hash) {
          continue;
        }

        elems[hash] = val;
      }
    }

    const recursivelyConvertRoomIds = (v: any) => {
      if (typeof v === "object") {
        if (!v) {
          return;
        }

        if (v instanceof Array) {
          return v.forEach((x) => recursivelyConvertRoomIds(x));
        }

        for (const key in v) {
          if (!v.hasOwnProperty(key)) {
            continue;
          }

          if (key === "roomId" && typeof v[key] === "string" && typeof dashIdToNewRoomId[v[key]] === "string") {
            v[key] = dashIdToNewRoomId[v[key]];
          } else {
            recursivelyConvertRoomIds(v[key]);
          }
        }
      }
    };

    if (json.electricalSystem) {
      recursivelyConvertRoomIds(json.electricalSystem);

      convertRoomHandleHashTable(json.electricalSystem.roomClearRules);
      convertRoomHandleHashTable(json.electricalSystem.roomEmbeddedGroups);
      convertRoomHandleHashTable(json.electricalSystem.roomIndependentLoadArrays);
    }

    // delete old cruft
    if (json.design !== undefined) {
      delete json.design.exteriorPalette;
      delete json.design.interiorPalette;
      delete json.design.maxBuildableDepth;
      delete json.design.maxBuildableWidth;
      delete json.design.parti;
    }

    return json;
  },
};

export default migration_0_0_53;
